import { type DataRouter } from 'react-router'

let router: DataRouter | null = null

/**
 * The suite's router, as reached from outside the React tree.
 *
 * Two callers navigate the suite from a callback, where no `useNavigate` is available: the Auth0
 * `onRedirectCallback` returns the user to their captured `returnTo`, and `useRegardAuth` sends a dead
 * EMR-embedded session to the launch notice.
 *
 * The router is registered here rather than imported from where it is built, because one of those callers
 * lives inside the route table it is built from. This module imports nothing at runtime, so it can be read
 * from anywhere in the suite without causing a cyclical import.
 */
export const setRouter = (suiteRouter: DataRouter): void => {
  router = suiteRouter
}

/**
 * Navigates the suite.
 *
 * A no-op before a router is registered, which is the case in a test that mounts a route subtree of its own
 * rather than the whole app. Such a test asserts on what it rendered, and has no suite-wide router that a
 * navigation could mean anything for.
 */
export const navigateSuite = (
  to: string,
  options?: { replace?: boolean },
): void => {
  void router?.navigate(to, options)
}
